export const menufinanceiro =  [
  {
    icon: 'home',
    path: '/dashboardFinanceiro',
    label: 'Página inicial',
  },
  {
    icon: 'paymentsIcon',
    path: '/contabancaria',
    label: 'Conta Bancária',
  },
  {
    icon: 'request_quote',
    path: '/contasreceber',
    label: 'Contas a Receber',
  },

  {
    icon: 'payment',
    path: '/contaspagar',
    label: 'Contas a Pagar',
  },

  {
    icon: 'featured_play_list',
    path: '/chequeemitidos',
    label: 'Cheques Emitidos',
  },

  {
    icon: 'subtitles',
    path: '/cheque',
    label: 'Cheque Cliente',
  },

  {
    icon: 'check_circle',
    path: '/confirmarboleto',
    label: 'Confirmar Boleto',
  },
  {
    icon: 'expand_circle_down',
    path: '/confirmarvale',
    label: 'Confirmar Vale',
  },

  {
    icon: 'transform',
    path: '/lancamentoentrecontas',
    label: 'Lançamento Entre Contas',
  },

  {
    icon: 'account_balance',
    path: '/conciliacao',
    label: 'Conciliação',
  },
];

export const menufinanceirorelatorio =  [
  {
    icon: 'print',
    path: '/relatoriocontaspagar',
    label: 'Contas Pagar',
  },
  {
    icon: 'print',
    path: '/relatoriocontaspagas',
    label: 'Contas Pagas',
  },
  {
    icon: 'print',
    path: '/relatoriocontasreceber',
    label: 'Receber',
  },
  {
    icon: 'print',
    path: '/relatoriocontasrecebidas',
    label: 'Recebidos',
  },
  {
    icon: 'print',
    path: '/relatoriocheque',
    label: 'Cheque',
  },
  {
    icon: 'print',
    path: '/rcustopatrimonio',
    label: 'Custo Património',
  },
  {
    icon: 'print',
    path: '/dreporfazenda',
    label: 'Resultado por Fazenda',
  },
  {
    icon: 'print',
    path: '/dregeral',
    label: 'Resultado Geral',
  },
  {
    icon: 'print',
    path: '/relatoriochequeemitidos',
    label: 'Cheque Emitidos',
  }
];